import { FourOhFour } from "./fourOhFour";

export default FourOhFour;